import { GeneralModel } from "./general.model";
import { Province } from "./province.model";
import { District } from "./district.model";
import { Ward } from "./ward.model";

export class Customer extends GeneralModel {
    isPublic: boolean;
    nameEn: string;
    address: string;
    addressNote: string;
    businessLicenseNumber: string;
    email: string;
    fax: string;
    legalRepresentative: string;
    notes: string;
    parentCustomerId: number;
    phoneNumber: string;
    salesOrganizationId: number;
    salesUserId: number;
    customerStatusId: number;
    stopServiceAlertDuration: number;
    supportOrganizationId: number;
    supportUserId: number;
    taxCode: string;
    tradingName: string;
    customerTypeId: number;
    provinceId: number;
    districtId: number;
    wardId: number;
    website: string;
    workTimeId: number;
    priceListId: number;
    isShowPrice: boolean;
    lat: number;
    lng: number;
    companyFrom: string;
    companyTo: string;
    discount: number;
    transferVehicleId: number;
    deliveryVehicleId: number;
    pickupVehicleId: number;

    province: Province;
    district: District;
    ward: Ward;
    code: string;
    userName: string;
    companyName: string;
    companyEmail: string;
    paymentTypeId: number;
    addressCompany: string;
    companyPhone: string;
    signName: string;
    signRole: string;
    totalCount: number;
    isAllowDebit: boolean;
    contractNumber: string;
    customerRepresentative: string;
    phoneNumberCustomer: any;
    taxCodeCustomer: string;
    identityCardCustomer: any;
    isAllowCNNN: boolean;
    isAllowCNNG: boolean;
    isSelected: boolean;
}